<template>
    <div>
        <el-radio-group v-model="showTab" @change="getChart">
            <el-radio-button label="1">{{ $t('Client.Measure.weight') }}</el-radio-button>
            <el-radio-button label="2">{{ $t('Measurement.Basalmetabolism') }}</el-radio-button>
            <el-radio-button label="3">{{ $t('Measurement.Fatweight') }}</el-radio-button>
        </el-radio-group>
        <div v-if="showTab === '1'" class="chart-show" ref="weight"></div>
        <div v-if="showTab === '2'" class="chart-show" ref="base"></div>
        <div v-if="showTab === '3'" class="chart-show" ref="fat"></div>
        <div style="margin-bottom: 30px;"></div>
        <div class="measure-title mb-5">
            {{ $t('Client.Measure.title') }}
            <el-tooltip
                class="item"
                style="float: right;"
                effect="dark"
                :content="$t('Client.Measure.data')"
                placement="top">
                <div
                    @click="handleShow('', 'add')"
                    class="inline-block iconfont icon-fitness-tianjia cursor-pointer">
                </div>
            </el-tooltip>
        </div>
         <el-table
            border
            :data="tableData"
            stripe
            style="width: 100%">
            <el-table-column prop="date" :label="$t('Measurement.Bodymeasuretime')" />
            <el-table-column prop="height" :label="$t('Measurement.height')" />
            <el-table-column prop="weight" :label="$t('Client.Measure.weight')" />
            <el-table-column prop="metabolize" :label="$t('Measurement.Basalmetabolism')" />
            <el-table-column prop="fatContent" :label="$t('Measurement.fatcontent')" />
            <el-table-column prop="address" :label="$t('Common.operating')">
                <template slot-scope="{row}">
                    <el-tooltip class="item" effect="dark" :content="$t('Measurement.details')" placement="top">
                        <div
                            @click="handleShow(row, 'show')"
                            class="inline-block iconfont icon-fitness-xiangqing cursor-pointer">
                        </div>
                    </el-tooltip>
                    <el-tooltip class="item" effect="dark" :content="$t('tooltip.edit')" placement="top">
                        <div
                            @click="handleShow(row, 'edit')"
                            class="inline-block iconfont icon-fitness-bianji1 ml-4 cursor-pointer">
                        </div>
                    </el-tooltip>
                    <el-tooltip class="item" effect="dark" :content="$t('tooltip.delete')" placement="top">
                        <div
                            @click="handleDelete(row)"
                            class="inline-block iconfont icon-fitness-shanchu1 ml-4 cursor-pointer">
                        </div>
                    </el-tooltip>
                </template>
            </el-table-column>
        </el-table>
        <!-- 分页 -->
        <el-pagination
            v-if="tableData && tableData.length"
            class="text-right mt-5"
            @current-change="fetchData"
            :current-page.sync="pagination.page"
            :page-size="pagination.size"
            layout="total, prev, pager, next, jumper"
            :total="pagination.total"
        ></el-pagination>
    </div>
</template>

<script>
import echarts from 'echarts';
import { Radio, RadioButton, RadioGroup} from 'element-ui';

export default {
    props: ['tableData', 'pagination', 'show'],
    components: {
        ElRadio: Radio,
        ElRadioButton: RadioButton,
        ElRadioGroup: RadioGroup,
    },
    data() {
        return {
            showTab: '1',
            clickRow: null,
        };
    },
    created() {
        this.fetchData();
    },
    watch: {
        'tableData'(val) {
            this.$nextTick(() => {
                this.getChart();
            });
        },
    },
    methods: {
        fetchData(val) {
            this.$emit('fetchData', val);
        },
        getChart() {
            if (this.showTab === '1') this.initWeightChart();
            else if (this.showTab === '2') this.initBaseChart();
            else if (this.showTab === '3') this.initFatChart();
        },
        initWeightChart() {
            this.$refs.weight.style.height = '300px';
            this.$refs.weight.style.width = '100%';
            const myChart = echarts.init(this.$refs.weight);
            myChart.clear();
            const option = {
                color: ['#0F8DF2'],
                xAxis: {
                    type: 'category',
                    // data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
                    data: this.tableData.map(el => el.date),
                },
                yAxis: {
                    type: 'value'
                },
                series: [{
                    data: this.tableData.map(el => el.weight),
                    type: 'line',
                    smooth: true,
                }],
                grid: {
                    left: '1%',
                    right: '-1%',
                    bottom: '2%',
                    containLabel: true,
                },
                tooltip: {
                    trigger: 'axis',
                },
            };
            myChart.setOption(option);
        },
        initBaseChart() {
            this.$refs.base.style.height = '300px';
            this.$refs.base.style.width = '100%';
            const myChart = echarts.init(this.$refs.base);
            myChart.clear();
            const option = {
                color: ['#0F8DF2'],
                xAxis: {
                    type: 'category',
                    data: this.tableData.map(el => el.date),
                },
                yAxis: {
                    type: 'value'
                },
                series: [{
                    data: this.tableData.map(el => el.metabolize),
                    type: 'line',
                    smooth: true,
                }],
                grid: {
                    left: '1%',
                    right: '-1%',
                    bottom: '2%',
                    containLabel: true,
                },
                tooltip: {
                    trigger: 'axis',
                },
            };
            myChart.setOption(option);
        },
        initFatChart() {
            this.$refs.fat.style.height = '300px';
            this.$refs.fat.style.width = '100%';
            const myChart = echarts.init(this.$refs.fat);
            myChart.clear();
            const option = {
                color: ['#0F8DF2'],
                xAxis: {
                    type: 'category',
                    data: this.tableData.map(el => el.date),
                },
                yAxis: {
                    type: 'value'
                },
                series: [{
                    data: this.tableData.map(el => el.fatContent),
                    type: 'line',
                    smooth: true,
                }],
                grid: {
                    left: '1%',
                    right: '-1%',
                    bottom: '2%',
                    containLabel: true,
                },
                tooltip: {
                    trigger: 'axis',
                },
            };
            myChart.setOption(option);
        },
        handleShow(row, type) {
            this.$emit('update:show', 'show');
            this.$emit('handleData', {
                row: row,
                type: type,
            });
        },
        handleDelete(row) {
            $ele.$confirm(this.$t('Message.Are_delete_this_data'), this.$t('Message.tip_title'), {
                confirmButtonText: this.$t('Message.confirm'),
                cancelButtonText: this.$t('Common.cancel'),
                type: 'warning',
            })
            .then(() => {
                API.delete(`client/body-test/${row.id}`).then(() => {
                    $ele.$message.success(this.$t('del_succ'));
                    this.$emit('fetchData');
                });
            })
            .catch(() => {});
        },
    },
};
</script>
<style lang="scss">
.measure-title {
    font-size: 15px;
    color: #212121;
    padding-left: 10px;
}
.inline-block {
    display: inline-block;
}
</style>
